export default __webpack_public_path__ + "static/ag-2323315e6c55232556d607c6cdff9445.jpg";